<template>
    <div>
        <tag/>
        <annotation-bookmark/>
        <share-annotation-bookmark :key="shareModalKey"/>
        <remove-annotation-bookmark/>
        <access-restricted/>
        <premium-content-category/>
        <cdp/>
        <es-errata-srcc/>
    </div>
</template>

<script>

import Tag from './Tag.vue';
import AnnotationBookmark from './AddEditAnnotationBookmark.vue';
import ShareAnnotationBookmark from './ShareAnnotationBookmark.vue';
import RemoveAnnotationBookmark from './RemoveAnnotationBookmark.vue';
import AccessRestricted from './insights/AccessRestricted.vue';
import PremiumContentCategory from './insights/PremiumContentCategory.vue';
import Cdp from './insights/Cdp.vue';
import EsErrataSrcc from './insights/EsErrataSrcc.vue';

export default {
    data() {
        return {
            shareModalKey: 0
        }
    },
    components: {
        Tag,
        AnnotationBookmark,
        ShareAnnotationBookmark,
        RemoveAnnotationBookmark,
        AccessRestricted,
        PremiumContentCategory,
        Cdp,
        EsErrataSrcc
    },
    created() {
        EventBus.listen('force-rerender-share-note', () => this.shareModalKey += 1);
    }
}
</script>